/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ErrorMessage } from '../model/errorMessage';
// @ts-ignore
import { FundingRatePaymentDto } from '../model/fundingRatePaymentDto';
// @ts-ignore
import { FundingRatePaymentRegisterRequest } from '../model/fundingRatePaymentRegisterRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService } from '../api.base.service';

export interface GetFundingRatePaymentsRequestParams {
  /** Exchange name for filtering */
  exchangeName?:
    | 'BINANCE_SPOT'
    | 'BINANCE_PERPETUAL'
    | 'BYBIT_SPOT'
    | 'BYBIT_PERPETUAL'
    | 'OKX_SPOT'
    | 'OKX_PERPETUAL'
    | 'AGGREGATE'
    | 'MULTIPLY'
    | 'DIVIDE'
    | 'PERP_SPOT_CHAINING'
    | 'LIQUIDITY_PROVIDER'
    | 'COINBASE_PERPETUAL'
    | 'KRAKEN_SPOT'
    | 'COINBASE_SPOT';
  /** Perpetual pair ID for filtering */
  perpetualPairId?: number;
  /** From time for filtering, inclusive */
  fromTime?: string;
  /** To time for filtering, inclusive */
  toTime?: string;
  /** Payment ids for filtering */
  paymentIds?: Array<string>;
  /** Sort direction by transactTime. ASC or DESC(default) */
  sortDirection?: 'ASC' | 'DESC';
  /** Skip count, should be &gt;&#x3D; 0. Default 0 */
  skipCount?: number;
  /** Maximum number of records to return (1-100). Default 100 */
  limit?: number;
}

export interface RegisterFundingRatePaymentsRequestParams {
  fundingRatePaymentRegisterRequest: Array<FundingRatePaymentRegisterRequest>;
}

@Injectable({
  providedIn: 'root',
})
export class FundingRatePaymentControllerService extends BaseService {
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration?: Configuration,
  ) {
    super(basePath, configuration);
  }

  /**
   * Gets funding rate payments (up to 100)
   * @endpoint get /v1/funding-rates/payments
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public getFundingRatePayments(
    requestParameters?: GetFundingRatePaymentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<Array<FundingRatePaymentDto>>;
  public getFundingRatePayments(
    requestParameters?: GetFundingRatePaymentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<Array<FundingRatePaymentDto>>>;
  public getFundingRatePayments(
    requestParameters?: GetFundingRatePaymentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<Array<FundingRatePaymentDto>>>;
  public getFundingRatePayments(
    requestParameters?: GetFundingRatePaymentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const exchangeName = requestParameters?.exchangeName;
    const perpetualPairId = requestParameters?.perpetualPairId;
    const fromTime = requestParameters?.fromTime;
    const toTime = requestParameters?.toTime;
    const paymentIds = requestParameters?.paymentIds;
    const sortDirection = requestParameters?.sortDirection;
    const skipCount = requestParameters?.skipCount;
    const limit = requestParameters?.limit;

    let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'exchangeName',
      <any>exchangeName,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'perpetualPairId',
      <any>perpetualPairId,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'fromTime',
      <any>fromTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'toTime',
      <any>toTime,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'paymentIds',
      <any>paymentIds,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'sortDirection',
      <any>sortDirection,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'skipCount',
      <any>skipCount,
      QueryParamStyle.Form,
      true,
    );

    localVarQueryParameters = this.addToHttpParams(
      localVarQueryParameters,
      'limit',
      <any>limit,
      QueryParamStyle.Form,
      true,
    );

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/funding-rates/payments`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<Array<FundingRatePaymentDto>>('get', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters.toHttpParams(),
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }

  /**
   * Registers funding rate payments
   * @endpoint post /v1/funding-rates/payments/register
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   * @param options additional options
   */
  public registerFundingRatePayments(
    requestParameters: RegisterFundingRatePaymentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<FundingRatePaymentRegisterRequest>;
  public registerFundingRatePayments(
    requestParameters: RegisterFundingRatePaymentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<FundingRatePaymentRegisterRequest>>;
  public registerFundingRatePayments(
    requestParameters: RegisterFundingRatePaymentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<FundingRatePaymentRegisterRequest>>;
  public registerFundingRatePayments(
    requestParameters: RegisterFundingRatePaymentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any> {
    const fundingRatePaymentRegisterRequest = requestParameters?.fundingRatePaymentRegisterRequest;
    if (fundingRatePaymentRegisterRequest === null || fundingRatePaymentRegisterRequest === undefined) {
      throw new Error(
        'Required parameter fundingRatePaymentRegisterRequest was null or undefined when calling registerFundingRatePayments.',
      );
    }

    let localVarHeaders = this.defaultHeaders;

    // authentication (bearerAuth) required
    localVarHeaders = this.configuration.addCredentialToHeaders(
      'bearerAuth',
      'Authorization',
      localVarHeaders,
      'Bearer ',
    );

    const localVarHttpHeaderAcceptSelected: string | undefined =
      options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/v1/funding-rates/payments/register`;
    const { basePath, withCredentials } = this.configuration;
    return this.httpClient.request<FundingRatePaymentRegisterRequest>('post', `${basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: fundingRatePaymentRegisterRequest,
      responseType: <any>responseType_,
      ...(withCredentials ? { withCredentials } : {}),
      headers: localVarHeaders,
      observe: observe,
      reportProgress: reportProgress,
    });
  }
}
